import { FC, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { Box, Text } from '@chakra-ui/react'
import { useAuthStore } from '@/stores/authStore'

interface AdminRouteProps {
  children: ReactNode
}

/**
 * 管理者専用ルートのガードコンポーネント。
 *
 * - 認証状態確認中はローディング表示
 * - 未認証の場合は /login にリダイレクト
 * - 管理者（users.role === 'admin'）でない場合は /dogs にリダイレクト
 *
 * 権限の最終判定は Cloud Functions 側でも行うため、このガードはUI上の
 * 出し分けであり、これ単体でセキュリティを担保するものではない。
 */
export const AdminRoute: FC<AdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuthStore()

  if (loading) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
        <Text color="gray.500">読み込み中...</Text>
      </Box>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (user.role !== 'admin') {
    return <Navigate to="/dogs" replace />
  }

  return <>{children}</>
}
